"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServiceFromMaybeLazyServiceIdentifier = getServiceFromMaybeLazyServiceIdentifier;
const common_1 = require("@inversifyjs/common");
function getServiceFromMaybeLazyServiceIdentifier(serviceIdentifier) {
    return common_1.LazyServiceIdentifier.is(serviceIdentifier)
        ? serviceIdentifier.unwrap()
        : serviceIdentifier;
}
//# sourceMappingURL=getServiceFromMaybeLazyServiceIdentifier.js.map